export const formatCardCollectionDate = (isoDate: string) => {
  const formattedDate = new Date(isoDate).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
  });
  return formattedDate;
};
